export default __webpack_public_path__ + "static/media/bsg-logo-2019.75ef43cf.svg";